import React from 'react';
import dayjs from 'dayjs';
import useMediaQuery from '@mui/material/useMediaQuery';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderMultiSectionDigitalClockTimeView } from '@mui/x-date-pickers/timeViewRenderers';
import styles from 'src/components/property-touring-hours/TimeSelect.module.css';

const TIME_VALUE_DATE = '2000-01-01';

export default function TimeSelect({
    value,
    onChange,
    testId,
    disabled,
}: {
    value: string;
    onChange: (value: string) => void;
    testId?: string;
    disabled?: boolean;
}) {
    const isMobile = useMediaQuery('(max-width:768px)');

    return (
        <TimePicker
            value={value ? dayjs(`${TIME_VALUE_DATE}T${value}`) : null}
            onChange={(newValue) => {
                if (newValue?.isValid()) {
                    onChange(newValue.format('HH:mm'));
                }
            }}
            disabled={disabled}
            closeOnSelect={false}
            minutesStep={15}
            viewRenderers={isMobile ? {
                hours: renderMultiSectionDigitalClockTimeView,
                minutes: renderMultiSectionDigitalClockTimeView,
            } : undefined}
            slotProps={{
                mobilePaper: {
                    className: styles.mobilePicker,
                },
                textField: {
                    size: 'small',
                    fullWidth: true,
                    inputProps: { 'data-testid': testId },
                },
            }}
        />
    );
}
